<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Isu Strategis</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input v-model="cari_value" @keyup="cari_data()"  type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">

                <br>
                <div class="row">
                    <div class="col-md-4">
                    <span class="huruf_input">Periode RPJMD</span>
                    <select @click="filterTrig()" v-model="filter2" :required="true" class="form-control show-tick" tabindex="-98">
                        <option value="" >-- Semua Periode --</option>
                        <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id"> {{data.periode}}</option>
                    </select>
                </div>
                </div>
                <br>
        <!-- ============================================================ MULAI ======================================================================== -->
            
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f1 text-center">
                            <th class="text-center" style="width: 5%">No</th>
                            <th class="text-center" style="width: 40%">Uraian Isu Strategis</th>
                            <th class="text-center" style="width: 40%">Keterangan</th>
                            <th class="text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="9" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="(data) in list_isu" :key="data.isu_strategis_id">
                                    <td class="text-center" >{{data.no_isu_strategis}}</td>
                                    <td>{{data.uraian}}</td>
                                    <td style="text-align: justify;">{{data.keterangan}}</td>
                                    <td class="tabel_center text-center" >
                                        <button @click="selectData(data)" class="btn bg-light-blue btn-xs waves-effect" title="Keterkaitan Permasalahan Pembangunan" id="edit_data" data-toggle="modal" data-target="#m_add_link">
                                            <i class="material-icons" >link</i>
                                        </button>
                                        &nbsp;
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                        &nbsp; 
                                        <button @click="removeData(data.isu_strategis_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>


                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                      &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>
                      &nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>  
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                <form @submit.prevent="addData()">    
                                    <div class="modal-body">
                            
                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Periode RPJMD</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                <div class="form-line">
                                                <select v-model="data.rpjmd_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                    <option value="" :disabled="true">-- Pilih Periode RPJMD --</option>
                                                    <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                                                </select>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">No Isu Strategis</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                            <div class="form-line">
                                                <input  v-model="data.no" :required="true" type="text" class="form-control" placeholder="Ex : 1">
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Uraian Isu Strategis</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="data.uraian" :required="true" type="text" class="form-control" placeholder="Ex : Pendapatan per kapita masih rendah yang mencapai 2.1 juta per bulan">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Keterangan </label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="data.keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>    
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>                                      
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <form @submit.prevent="editData()">    
                                    <div class="modal-body">
                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Periode RPJMD</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                <div class="form-line">
                                                <select v-model="data.rpjmd_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                    <option value="" :disabled="true">-- Pilih Periode RPJMD --</option>
                                                    <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" :value="data.rpjmd_id">	{{data.periode}}</option>
                                                </select>
                                                </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                        <div class="col-md-3 form-control-label">
                                            <label for="kode">No Isu Strategis</label>
                                        </div>
                                        <div class="col-md-9">
                                            <div class="form-group">
                                            <div class="form-line">
                                                <input  v-model="data.no" :required="true" type="text" class="form-control" placeholder="Ex : 1">
                                            </div>
                                            </div>
                                        </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Uraian Isu Strategis</label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="data.uraian" :required="true" type="text" class="form-control" placeholder="Ex : Pendapatan per kapita masih rendah yang mencapai 2.1 juta per bulan">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-3 form-control-label">
                                                <label for="kode">Keterangan </label>
                                            </div>
                                            <div class="col-md-9">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="data.keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                        <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                    </div>
                                </form>                                
                            </div>
                        </div>
                    </div>
                    
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST PERMASALAHAN PEMBANGUNAN  xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_add_link" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()"  type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                    
                                    <h4 class="modal-title" id="largeModalLabel">Tambahkan Permasalahan Pembangunan</h4>
                                </div>
                                
                                <div class="modal-body">
                                    <button @click="getDataPerma()" type="submit" data-toggle="modal" data-target="#m_pilih_skpd" class="btn btn-info waves-effect ">
                                        TAMBAH LIST
                                    </button>
                                    <hr>
                                    <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                        <tr class="bg-info">
                                            <th style="width: 5%">No.</th>
                                            <th style="width: 50%">Uraian</th>
                                            <th style="width: 40%">Bidang Urusan</th>
                                            <th style="width: 5%">Pilihan</th>
                                        </tr>

                                        </thead>
                                        <tbody>
                                            <!-- v-for="(data, index) in list_urusan" track-by="data.createdtime" -->
                                            <tr class="h_isitable" v-for="(data) in list_perm_relate" :key="data.permasalahan_pembangunan_id">
                                                <td>{{data.kodeku}}</td>
                                                <td>{{data.uraian_permasalahan}}</td>
                                                <td>{{data.nama_bidang}}</td>
                                                <td class="text-center"> 
                                                    <button type="submit" @click="removeDataRelate(data.relasi_id)" class="btn btn-danger waves-effect btn-xs"> <i class="material-icons">delete</i> </button>
                                                </td>
                                            </tr>

                                        </tbody>
                                    </table>
                                    

                                </div>
                                <div class="modal-footer">
                                    <button @click="emptyData()" type="button" class="btn btn-warning waves-effect"  data-dismiss="modal" aria-label="Close">TUTUP</button>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST PERMASALAHAN PEMBANGUNAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
        
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD PERMASALAHAN PEMBANGUNAN  xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_pilih_skpd" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span></button>                                    
                                    <h4 class="modal-title" id="largeModalLabel">Tambahkan Satuan Kerja</h4>
                                </div>

                                <form @submit.prevent="addDataPerm()">
                                    <div class="modal-body">
                                                        
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                            <tr class="bg-info">
                                                <th style="width: 5%">No.</th>
                                                <th style="width: 50%">Uraian</th>
                                                <th style="width: 40%">Bidang Urusan</th>
                                                <th style="width: 5%"></th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                                <!-- v-for="(data, index) in list_urusan" track-by="data.createdtime" -->
                                                <tr class="h_isitable" v-for="(data) in list_perm" :key="data.permasalahan_pembangunan_id">
                                                    <td>{{data.kodeku}}</td>
                                                    <td>{{data.uraian}}</td>
                                                    <td>{{data.nama_bidang_urusan}}</td>
                                                    <td class="text-center">
                                                        <!-- <input type="hidden" v-model="dataSKPD.bidang_id" > -->
                                                        <!-- <div class="demo-checkbox text-center"> -->
                                                            <input v-model="permasalahan_pembangunan_id" type="checkbox" :id="data.permasalahan_pembangunan_id" :value="data.permasalahan_pembangunan_id"/>
                                                            <label :for="data.permasalahan_pembangunan_id"></label>
                                                        <!-- </div> -->
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="submit"  class="btn btn-info waves-effect ">SIMPAN</button>
                                        <button type="button" class="btn btn-danger waves-effect"  data-dismiss="modal" aria-label="Close">TUTUP</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL ADD PERMASALAHAN PEMBANGUNAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
               

                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/isu_strategis/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_Perm = URL_APP+'api/v1/planning_permasalahan_pembangunan/';
    
    export default {
        name: "planning_urusan",
        data() {
            return {
                data:{
                    isu_strategis_id : '',
                    no: '',
                    rpjmd_id: '',
                    uraian: '',
                    keterangan: '',
                },
                dataRelate:{
                    _id: '',
                    _id_array : [] ,
                },
                no: '',
                rpjmd_id: '',
                uraian: '',
                keterangan: '',
                id_isu: '',
                filter2: '',
                list_isu: [],
                list_rpjmd: [],
                list_perm: [],
                list_perm_relate: [],
                permasalahan_pembangunan_id: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            };
        },

        mounted() {
            this.getData();
            this.getDataRPJMD();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addDataPerm: function(){
                fetch(ADD_URL_Perm+'addDataRelate', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        permasalahan_pembangunan_id : this.permasalahan_pembangunan_id,
                        isu_strategis_id : this.data.isu_strategis_id
                    })
                }).then(res => res.json()).then((data_bidang) => {
                    // console.log(data_bidang);
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getDataPermaRelate();
                    this.getDataPerma();
                    
                });
                // console.log(this.permasalahan_pembangunan_id);
            },
            removeDataRelate : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL_Perm+"deleteDataRelateIsuBidang", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getDataPermaRelate();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getDataPerma: function(){
                this.list_perm = [];
                fetch(ADD_URL_Perm+'readDataFromIsu', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      rpjmd_id : this.data.rpjmd_id,  
                    })
                }).then((res) => res.json()).then((res_data) => {

                    var list_perm_relate = this.list_perm_relate

                    for (let j = 0; j < list_perm_relate.length; j++) {
                        const element = list_perm_relate[j].permasalahan_pembangunan_id;
                        
                        for( var i = 0; i < res_data.length; i++){ 
                            if ( res_data[i].permasalahan_pembangunan_id == element) {
                                res_data.splice(i, 1); 
                            }
                        }
                    }
                    this.list_perm = res_data;
                })
            },
            filterTrig: function(){
                if (this.filter2 == ''){
                    this.getData();
                } else {
                    fetch(ADD_URL+'readDataFilter', {
                        method : 'POST',
                        headers : {
                          "content-type": "application/json",
                          authorization: "kikensbatara " + localStorage.token
                        },
                        body : JSON.stringify({
                            bidang_id: this.filter,
                            rpjmd_id: this.filter2,
                            data_ke : this.page_first,
                            cari_value : this.cari_value
                        })
                    }).then((res) => res.json()).then((data_rpjmd) => {
                      this.list_isu = data_rpjmd.data;
                    })
                }
            },
            getDataRPJMD: function(){
                fetch(ADD_URL_RPJMD+'readDataNoPaging', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                  this.list_rpjmd = data_rpjmd.data;
                })
            },
            getData: function(){
                fetch(ADD_URL+'read', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_isu = data_urusan.data;
                  this.page_last = data_urusan.jml_data;
                  this.cek_load_data = false;
                })
            },
            editData: function(){                
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){

                this.data = {
                    isu_strategis_id : data.isu_strategis_id,
                    no: data.no_isu_strategis,
                    rpjmd_id: data.rpjmd_id,
                    uraian: data.uraian,
                    keterangan: data.keterangan,
                };
                this.getDataPermaRelate();
            },
            getDataPermaRelate: function(){
                // console.log(this.dataRelate._id);
                fetch(ADD_URL_Perm+'readDataRelasiIsuBidang', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      isu_strategis_id : this.data.isu_strategis_id,  
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_perm_relate = res_data;
                //   console.log(res_data);
                })
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"delete", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.list_perm_relate = [];
                this.list_perm = [];
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
